import React, { useState } from 'react';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  
  const [formStatus, setFormStatus] = useState({
    submitted: false,
    success: false,
    message: '',
    loading: false
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Set loading state
    setFormStatus({
      ...formStatus,
      loading: true
    });
    
    // Your Web3Forms access key - should ideally be in an environment variable
    const accessKey = "3f202e5a-783f-43d9-b916-34580a1741e4";
    
    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          access_key: accessKey,
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message,
          from_name: "Portfolio Contact Form",
          botcheck: "", // Add this to help with spam detection
          redirect: "", // Optional redirect URL
          replyto: formData.email, // Set reply-to as the sender's email
        })
      });
      
      const data = await response.json();
      
      if (data.success) {
        setFormStatus({
          submitted: true,
          success: true,
          message: 'Thank you for your message! I will get back to you soon.',
          loading: false
        });
        
        // Reset form after successful submission
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
      } else {
        // Error state with more detailed message
        setFormStatus({
          submitted: true,
          success: false,
          message: `Error: ${data.message || 'Something went wrong. Please try again later.'}`,
          loading: false
        });
        console.error('Form submission error:', data);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setFormStatus({
        submitted: true,
        success: false,
        message: 'Network error. Please check your connection and try again.',
        loading: false
      });
    }
  };

  return (
    <div className="contact-container">
      {/* Header Section */}
      <section className="contact-header">
        <h1 className="contact-title">Get In <span className="highlight">Touch</span></h1>
        <div className="contact-subtitle">Let's talk about your project</div>
      </section>

      <div className="contact-content">
        {/* Contact Information */}
        <div className="contact-info-container">
          <div className="contact-card">
            <h2 className="info-title">Contact <span className="highlight">Information</span></h2>
            <p className="info-description">
              Feel free to reach out to me any time. I prefer to talk over email, especially since we may be in different time zones.
            </p>

            <div className="info-items">
              <div className="info-item">
                <div className="info-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" className="icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <div className="info-detail">
                  <h3 className="info-label">Email</h3>
                  <a href="mailto:email@example.com" className="info-value">aditikumari5281@gmail.com</a>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" className="icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <div className="info-detail">
                  <h3 className="info-label">Phone</h3>
                  <a href="tel:+11234567890" className="info-value">+91 0000000000</a>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" className="icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <div className="info-detail">
                  <h3 className="info-label">Location</h3>
                  <p className="info-value">Chennai TamilNadu</p>
                </div>
              </div>
            </div>

            <h3 className="social-title">Connect with me</h3>
            <div className="social-links">
              <a href="https://www.linkedin.com/in/aditi-singh-a533031ab/" target="_blank" rel="noopener noreferrer" className="social-link">
                <svg xmlns="http://www.w3.org/2000/svg" className="social-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.454C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.225 0z" />
                </svg>
              </a>
              <a href="https://github.com/kumariaditi52" target="_blank" rel="noopener noreferrer" className="social-link">
                <svg xmlns="http://www.w3.org/2000/svg" className="social-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" />
                </svg>
              </a>
              <a href=" " target="_blank" rel="noopener noreferrer" className="social-link">
                <svg xmlns="http://www.w3.org/2000/svg" className="social-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Contact Form */}
        <div className="contact-form-container">
          <div className="form-card">
            <h2 className="form-title">Send Me a <span className="highlight">Message</span></h2>
            
            {formStatus.submitted && (
              <div className={`form-message ${formStatus.success ? 'success' : 'error'}`}>
                {formStatus.message}
              </div>
            )}
            
            <form onSubmit={handleSubmit} className="contact-form">
              {/* Hidden honeypot field to prevent spam */}
              <input type="checkbox" name="botcheck" id="botcheck" className="hidden" style={{ display: 'none' }} />
              
              <div className="form-grid">
                <div className="form-group">
                  <label htmlFor="name" className="form-label">Full Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-input"
                    placeholder="John Doe"
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email" className="form-label">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-input"
                    placeholder="aditikumari5281@gmail.com"
                    required
                  />
                </div>
              </div>
              
              <div className="form-group">
                <label htmlFor="subject" className="form-label">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="Project Inquiry"
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="message" className="form-label">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  className="form-textarea"
                  placeholder="Tell me about your project..."
                  rows="5"
                  required
                ></textarea>
              </div>
              
              <button 
                type="submit" 
                className={`submit-button ${formStatus.loading ? 'loading' : ''}`}
                disabled={formStatus.loading}
              >
                {formStatus.loading ? (
                  <span className="loading-spinner"></span>
                ) : (
                  <>
                    <span className="button-text">Send Message</span>
                    <svg xmlns="http://www.w3.org/2000/svg" className="button-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Map or Additional Info Section */}
      <section className="map-section">
        <h2 className="section-title">Find Me <span className="highlight">Here</span></h2>
        <div className="map-container">
          {/* You can replace this with an actual map component like Google Maps */}
          <div className="map-placeholder">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d100939.98555098464!2d-122.50764017948534!3d37.75781499229416!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80859a6d00690021%3A0x4a501367f076adff!2sSan%20Francisco%2C%20CA%2C%20USA!5e0!3m2!1sen!2sin!4v1644982669429!5m2!1sen!2sin" 
              width="100%" 
              height="400" 
              style={{ border: 0 }} 
              allowFullScreen="" 
              loading="lazy"
              title="Location Map"
              className="map-iframe"
            ></iframe>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      {/* <section className="faq-section">
        <h2 className="section-title">Frequently Asked <span className="highlight">Questions</span></h2>
        <div className="faq-container">
          <div className="faq-item">
            <h3 className="faq-question">What services do you offer?</h3>
            <p className="faq-answer">
              I offer a range of web development services including frontend development, 
              backend development, full-stack development, responsive design, and web application 
              development using modern technologies like React, Node.js, and more.
            </p>
          </div>
          
          <div className="faq-item">
            <h3 className="faq-question">What is your typical project timeline?</h3>
            <p className="faq-answer">
              Project timelines vary depending on complexity and scope. A simple website might take 
              2-4 weeks, while a complex web application could take 2-3 months. I'll provide a detailed 
              timeline estimate after discussing your specific requirements.
            </p>
          </div>
          
          <div className="faq-item">
            <h3 className="faq-question">How do you handle project pricing?</h3>
            <p className="faq-answer">
              I offer flexible pricing options including fixed-price quotes for well-defined projects 
              and hourly rates for ongoing work. After understanding your project requirements, 
              I'll provide a detailed proposal with transparent pricing.
            </p>
          </div>
          
          <div className="faq-item">
            <h3 className="faq-question">Do you offer ongoing maintenance?</h3>
            <p className="faq-answer">
              Yes, I offer website maintenance and support services to ensure your site remains 
              up-to-date, secure, and functioning optimally. We can discuss maintenance packages 
              based on your specific needs.
            </p>
          </div>
        </div>
      </section> */}
    </div>
  );
}

export default Contact;
